






























































import { Component, PropSync, Vue } from 'vue-property-decorator';

// Domain
import { RetirementInvestorGoalCalculatorDto } from '@/modules/flagship/retirement-investor-goal-calculator/domain/dtos/retirement-investor-goal-calculator-dto';

import RetirementFundContributionsViewModel from
  '@/vue-app/view-models/components/goals-dashboard/create-goal/retirement-fund/retirement-fund-inflation-info-view-model';

@Component({
  name: 'RetirementFundInflationInfoDialog',
})
export default class RetirementFundInflationInfoDialog extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  @PropSync('retirementGoalCalculatorDto', { type: Object, required: true })
  synced_retirement_goal_calculator_dto!: RetirementInvestorGoalCalculatorDto;

  view_model = Vue.observable(
    new RetirementFundContributionsViewModel(this),
  );

  closeModal() {
    this.synced_is_open = false;
  }

  created() {
    this.view_model.initialize(this.synced_retirement_goal_calculator_dto);
  }
}
